import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil, finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { IdentityDocumentBlobCacheService } from '@app/core/services/identity-reports-blob-cache.service';


export interface TilePreviewDialogData {
  civilId: string;
  docId: number;
  docName: string;
}

@Component({
  selector: 'itfg-tile-preview-dialog',
  templateUrl: './tile-preview-dialog.component.html',
  styleUrl: './tile-preview-dialog.component.scss',
  standalone: false,
})
export class TilePreviewDialogComponent implements OnInit, OnDestroy {
  imageUrl: string | null = null;
  loading = false;
  error = false;

  private ownedUrl: string | null = null;
  private readonly unsubscribe = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: TilePreviewDialogData,
    readonly dialogRef: MatDialogRef<TilePreviewDialogComponent>,
    private readonly blobCache: IdentityDocumentBlobCacheService
  ) {}

  ngOnInit(): void {
    const cached = this.blobCache.peek(this.data.civilId, this.data.docId);
    if (cached) {
      this.materialize(cached);
      return;
    }

    this.loading = true;
    this.blobCache
      .get$(this.data.civilId, this.data.docId)
      .pipe(
        takeUntil(this.unsubscribe),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: (blob: Blob) => this.materialize(blob),
        error: (err: HttpErrorResponse) => {
          console.error('[TilePreviewDialog] load error', err);
          this.error = true;
        },
      });
  }

  private materialize(blob: Blob): void {
    this.ownedUrl = URL.createObjectURL(blob);
    this.imageUrl = this.ownedUrl;
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.ownedUrl) URL.revokeObjectURL(this.ownedUrl);
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}